import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VmeCommonModule } from '../../../vme-common.module';
import { SelectItem } from 'primeng';
import { IDropdownItem } from 'src/app/interfaces/drop-down-item';
import { AdditionalChargeService, IncidentsService } from 'src/app/services';
import { AdditionalChargeStatusEnum } from 'src/app/enums/additional-charge.enum';

@Component({
  selector: 'change-expense-status',
  styleUrls: ['../../job-screen/common/common-scss/job-screen-additional-costs-common.scss'],
  templateUrl: './change-expense-status.component.html',
  standalone: true,
  imports: [VmeCommonModule],
})
export class ChangeExpenseStatusComponent implements OnInit {
  constructor(private additionalChargeService: AdditionalChargeService) {}
  @Input() visible = false;
  @Input() selectedStatus: number;
  @Input() statusAdditionalChargeId: number;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() confirmChangeStatus = new EventEmitter<boolean>();
  public statusOptions: SelectItem[] = [];
  public assignees: IDropdownItem[] = [];
  public ngOnInit(): void {
    this.getAdditionalChargeStatuses();
  }

  private getAdditionalChargeStatuses() {
    this.additionalChargeService.getAdditionalChargeStatuses().then((r) => {
      var onlyPendingStatuses = r.filter(
        (x) =>
          x.id === AdditionalChargeStatusEnum.InternalRequest ||
          x.id == AdditionalChargeStatusEnum.InternalUpdate ||
          x.id == AdditionalChargeStatusEnum.Pending ||
          x.id == AdditionalChargeStatusEnum.SupplierRequest ||
          x.id == AdditionalChargeStatusEnum.SupplierUpdated,
      );
      this.statusOptions = onlyPendingStatuses.map((x) => {
        return {
          label: x.name,
          value: x.id,
        };
      });
    });
  }

  saveChangeExpenseStatus() {
    if (this.selectedStatus) {
      this.additionalChargeService
        .changeExpenseStatus(this.statusAdditionalChargeId, this.selectedStatus)
        .then(() => {
          this.confirmChangeStatus.emit(true);
        })
        .catch(() => {
          this.confirmChangeStatus.emit(false);
        });
    } else {
      this.confirmChangeStatus.emit(false);
    }
  }

  closeExpenseStatusDialog() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
